import React from 'react';
import styles from './Backdrop.module.css';

const backdrop = props => {
	const bdClass = `${styles.Backdrop} ${props.show ? (props.fadeBackdrop ? styles.ShowFadedBackdrop : styles.ShowBackdrop) : styles.HideBackdrop}`;
	// just showing faded backdrop (lesser opacity) when we have a true 'props.fadeBackdrop'
	return (
		<div
			className={bdClass}
			onClick={() => props.close()}
		/>
	)
};

export default backdrop;